import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { FormsModule } from '@angular/forms';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Router, RouterLink } from '@angular/router';
import Intercom, { shutdown } from '@intercom/messenger-js-sdk';
import { DateTime } from 'luxon';
import { NzAvatarModule } from 'ng-zorro-antd/avatar';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { DeviceDetectorService } from 'ngx-device-detector';
import { take } from 'rxjs';
import { ContentModalComponent } from '../../../basic/modal/content-modal/content-modal.component';
import { BoardHolderService } from '../../../core/board/board.holder.service';
import { UserClerkService } from '../../../core/user/user-clerk.service';
import { VERSION } from './../../../../version';
import { SentryService } from './../../../core/sentry/sentry.service';

@Component({
  selector: 'app-interview-sidebar',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,

    NzLayoutModule,
    NzMenuModule,
    NzButtonModule,
    NzIconModule,
    RouterLink,
    NzAvatarModule,
    NzDropDownModule,
    NzModalModule,
    NzInputModule,

    MatTooltipModule,

    ContentModalComponent,
  ],
  templateUrl: './interview-sidebar.component.html',
  styleUrl: './interview-sidebar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InterviewSidebarComponent {
  isSendFeedbackVisible = false;

  isMobile = signal<boolean>(false);

  showMobileModal = signal<boolean>(false);

  isCollapsed = true;

  // unlimitedPointsModal = false;

  user = toSignal(this.userClerkService.getUser$());

  constructor(
    private router: Router,
    private userClerkService: UserClerkService,
    private sentryService: SentryService,
    private boardHolderService: BoardHolderService,
    private breakpointObserver: BreakpointObserver,
    private deviceService: DeviceDetectorService
  ) {}

  ngOnInit() {
    Intercom({
      app_id: 'bats397g',
      user_id: this.user()!.id,
      name: this.user()!.firstName ?? 'User',
      email: this.user()!.primaryEmailAddress?.emailAddress,
      created_at: DateTime.utc().toUnixInteger(),
    });

    this.breakpointObserver.observe([Breakpoints.Handset]).subscribe((result) => {
      this.isMobile.set(result.matches);
    });

    if (this.deviceService.isMobile()) {
      this.showMobileModal.set(true);
    }
  }

  ngOnDestroy() {
    shutdown();
  }

  portraitUrl = computed(() => {
    return this.userClerkService.portraitUrl();
  });

  credits = computed(() => {
    return this.user()?.publicMetadata['credits'] as number;
  });

  onLogoutClick() {
    this.userClerkService.signOut$().pipe(take(1)).subscribe();
  }

  onContactSupportClick() {
    this.email = this.user()!.primaryEmailAddress?.emailAddress;
    this.name = this.boardHolderService.myPersonalBoard()?.userBoardConfig?.preferredName;

    this.isSendFeedbackVisible = true;
  }

  onGetMorePointsClick() {
    const url = this.router.serializeUrl(this.router.createUrlTree(['/pricing']));
    window.open(url, '_blank');
    // this.unlimitedPointsModal = true;
  }

  onPointsClick() {
    this.router.navigate(['/history']);
  }

  onWalletClick() {
    this.router.navigate(['/history']);
  }

  onMyAccountClick() {
    this.router.navigate(['/my-account']);
  }

  feedback?: string;
  name?: string;
  email?: string;

  handleSendFeedbackCancel() {
    this.isSendFeedbackVisible = false;
    this.feedback = undefined;
  }

  handleSendFeedbackOk() {
    this.isSendFeedbackVisible = false;
    if (this.feedback) {
      this.sentryService.sendFeedback(this.name ?? '', this.email ?? '', this.feedback);
    }

    this.feedback = undefined;
  }

  version() {
    return VERSION;
  }
}
